<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'

const route = useRoute()
const router = useRouter()
const { t } = useI18n()

// Bottom navigation items (limited for mobile)
const navItems = computed(() => [
  {
    name: 'dashboard',
    path: '/',
    icon: 'pi pi-home',
    label: t('nav.dashboard'),
  },
  {
    name: 'glucose',
    path: '/glucose',
    icon: 'pi pi-chart-line',
    label: t('nav.glucose'),
  },
  {
    name: 'nutrition',
    path: '/nutrition',
    icon: 'pi pi-apple',
    label: t('nav.nutrition'),
  },
  {
    name: 'medication',
    path: '/medication',
    icon: 'pi pi-heart',
    label: t('nav.medication'),
  },
  {
    name: 'messages',
    path: '/messages',
    icon: 'pi pi-comments',
    label: t('nav.messages'),
  },
])

function isActive(path: string): boolean {
  if (path === '/') {
    return route.path === '/'
  }
  return route.path.startsWith(path)
}

function navigate(path: string) {
  router.push(path)
}
</script>

<template>
  <nav class="fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 z-30 safe-area-pb">
    <div class="flex items-center justify-around h-16">
      <button
        v-for="item in navItems"
        :key="item.name"
        :class="[
          'flex flex-col items-center justify-center flex-1 h-full transition-colors',
          isActive(item.path)
            ? 'text-primary-600 dark:text-primary-400'
            : 'text-gray-500 dark:text-gray-400'
        ]"
        @click="navigate(item.path)"
      >
        <i :class="[item.icon, 'text-xl']" />
        <span class="text-xs mt-1 hide-in-wordless">{{ item.label }}</span>
      </button>
    </div>
  </nav>
</template>

<style scoped>
.safe-area-pb {
  padding-bottom: env(safe-area-inset-bottom, 0);
}
</style>
